module.exports = __webpack_public_path__ + "img/coo_pos.7e12df36.png";